import { render, staticRenderFns } from "./UserJourneyDetails.vue?vue&type=template&id=4c53fb18&"
import script from "./UserJourneyDetails.vue?vue&type=script&lang=js&"
export * from "./UserJourneyDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserJourneyDetails.vue?vue&type=style&index=0&id=4c53fb18&prod&lang=scss&"
import style1 from "./UserJourneyDetails.vue?vue&type=style&index=1&id=4c53fb18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports